export const TABLE_SEARCH_NEW_HIDDEN_COLUMNS_SET_EVENT = 'report-new-hidden-columns-set';
